<mat-list-item>
  <ng-content select="app-nav-title"></ng-content>
</mat-list-item>
